/* Source: /home/sidsolaiyappan/skooch_ai/shared/analytics.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
function shouldLoadMicrosoftClarity(hostname, alreadyLoaded) {
  let _host = String((hostname || ""));
  if (!_host.endsWith("skooch.ai")) {
    return false;
  }
  if (alreadyLoaded) {
    return false;
  }
  return true;
}
function loadMicrosoftClarity() {
  try {
    let _alreadyLoaded = false;
    try {
      if (window.__skoochClarityLoaded) {
        _alreadyLoaded = true;
      }
    } catch (__jac_e) {
      if (true) {
        let _fe = __jac_e;
      } else {
        throw __jac_e;
      }
    }
    if (!shouldLoadMicrosoftClarity(window.location.hostname, _alreadyLoaded)) {
      return;
    }
    window.__skoochClarityLoaded = true;
    let _stub = document.createElement("script");
    _stub.text = "window.clarity=window.clarity||function(){(window.clarity.q=window.clarity.q||[]).push(arguments)};";
    document.head.appendChild(_stub);
    let _script = document.createElement("script");
    _script.async = true;
    _script.src = "https://www.clarity.ms/tag/wxza35xh43";
    let _first = document.getElementsByTagName("script")[0];
    if ((_first && _first.parentNode)) {
      _first.parentNode.insertBefore(_script, _first);
    } else {
      document.head.appendChild(_script);
    }
  } catch (__jac_e) {
    if (true) {
      let _clErr = __jac_e;
      console.log("Clarity load (non-fatal):", _clErr);
    } else {
      throw __jac_e;
    }
  }
}
export {loadMicrosoftClarity, shouldLoadMicrosoftClarity};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:shouldLoadMicrosoftClarity": {"is_writer": false, "touches": ["*"]}, "func:loadMicrosoftClarity": {"is_writer": true, "touches": ["*"]}}); };
//# sourceMappingURL=analytics.js.map
